import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import utils from '../lib/utils';
import { userLogout, forbiddenAccess } from './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });
/* ========= getVoiceStatus API ========= */

const getVoiceStatusStart = () => ({
  type: types.GET_VOICE_STATUS_START,
});

const getVoiceStatusSuccess = (data) => ({
  type: types.GET_VOICE_STATUS_SUCCESS,
  data,
});

const getVoiceStatusFail = () => ({
  type: types.GET_VOICE_STATUS_FAIL,
});

export function getVoiceStatus(params) {
  return (dispatch) => {
    dispatch(getVoiceStatusStart());
    request
      .get(`${window.Config.API_URL}/livedashboard/business/incoming_voice/status`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(getVoiceStatusSuccess(data));
        } else {
          dispatch(getVoiceStatusFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(getVoiceStatusFail());
      });
  };
}

/* ========= updateVoiceStatus API ========= */

const updateVoiceStatusStart = () => ({
  type: types.UPDATE_VOICE_STATUS_START,
});

const updateVoiceStatusSuccess = (data) => ({
  type: types.UPDATE_VOICE_STATUS_SUCCESS,
  data,
});

const updateVoiceStatusFail = () => ({
  type: types.UPDATE_VOICE_STATUS_FAIL,
});

export function updateVoiceStatus(params) {
  return (dispatch) => {
    dispatch(updateVoiceStatusStart());
    request
      .post(`${window.Config.API_URL}/livedashboard/business/incoming_voice/status`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ 'status': params })
      .then((resp) => {
        if (resp.statusCode === 200) {
          let features = utils.getCookie('features');
          console.log('features', features);
          let updated;
          if (params === 'DISABLED') {
            updated = features.filter((f) => f !== 'INCOMING_VOICE_LIVE');
          } else {
            if (!features.includes('INCOMING_VOICE_LIVE')) {
              updated = [...features, 'INCOMING_VOICE_LIVE'];
            } else {
              updated = features;
            }
          }
          // Save as JSON string
          console.log('features', features);
          utils.setCookie('features', updated);
          const data = JSON.parse(resp.text);
          dispatch(updateVoiceStatusSuccess(data));
        } else {
          dispatch(updateVoiceStatusFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(updateVoiceStatusFail());
      });
  };
}

/* ========= updateWeavePhone API ========= */

const updateWeavePhoneStart = () => ({
  type: types.UPDATE_WEAVE_PHONE_START,
});

const updateWeavePhoneSuccess = (data) => ({
  type: types.UPDATE_WEAVE_PHONE_SUCCESS,
  data,
});

const updateWeavePhoneFail = () => ({
  type: types.UPDATE_WEAVE_PHONE_FAIL,
});

export function updateWeavePhone(params) {
  return (dispatch) => {
    dispatch(updateWeavePhoneStart());
    request
      .post(`${window.Config.API_URL}/business/weave/v1/updatePhone`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(updateWeavePhoneSuccess(data));
        } else {
          dispatch(updateWeavePhoneFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(updateWeavePhoneFail());
      });
  };
}

export function clearVoiceErrorMessage() {
  return {
    type: types.CLEAR_ERROR_MEESSAGE_VOICE,
  };
}
